<template>
  <div class="subCategories">
    <!-- 标题栏 -->
    <!-- <van-nav-bar left-arrow title="分类页面" @click-left="onClickLeft" /> -->
    <!-- <van-nav-bar :title="category" left-arrow @click-left="onClickLeft" /> -->
    <!-- 内容 -->
    <div class="page">
      <div class="container">
        <div
          class="kqb-section"
          v-for="(item, index) in SecondCategories"
          @click="pageJump('/curriculumSchedule?from=mixun', item)"
          :key="index"
        >
          <div class="content">
            <span class="title">{{ item.goodsCategoryName }}</span>
          </div>
        </div>
        <!--最后一个是站位用的，不能删掉-->
        <div class="kqb-section" style="background-color: transparent">
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "subCategories",
  data() {
    return {
      category: '已学课程',
      message: "",
      goodsCategoryNameEn:'',//名称
      goodsCategoryList: [],
      SecondCategories:[] //二级分类
    };
  },
  created() {
    let params = this.$route.query;
    let goodsCategoryNameEn = params.goodsCategoryNameEn;
    if( typeof goodsCategoryNameEn === 'undefined' ){
      console.log("true")
      this.category = params.goodsCategoryName;
      this.goodsCategoryId = params.goodsCategoryId;
      console.log("goodsCategoryId "+this.goodsCategoryId)
      // this.getGoosCategory();
      this.getSecondCategories();
    }else{
      console.log("false")
      this.goodsCategoryNameEn = goodsCategoryNameEn;
      console.log(goodsCategoryNameEn)
      this.getSecondCategoriesByName();
    }

  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    // 页面跳转
    pageJump(uri, item) {
      const thisObj = this;
      let queryData = {
        goodsCategoryName: item.goodsCategoryName,
        goodsCategoryId: item.goodsCategoryId,
      };
      thisObj.$router.push({
        path: uri,
        query: queryData,
      });
    },
    getGoosCategory() {
      var thisObj = this;
      //   var storeId = this.$root.userInfo.storeId
      var storeId = "STOREINFOFBCB01621A0AFE62F036E8C9D0B01BCD#";
      thisObj.$api
        .get(
          thisObj.requestUrl +
            "/knowledge/goods/category/getKnowledgeGoodsCategory?fromDevice=h5&storeId=" +
            storeId,
          {}
        )
        .then((res) => {
          console.log(res);
          if (res.resultCode === 200 && res.success) {
            thisObj.goodsCategoryList = res.resultData;
          } else {
            thisObj.$util.requetServerError(res.resultMsg);
          }
        })
        .catch(function (error) {
          thisObj.$util.requetServerError(error);
        });
    },
    //获取二级分类
    getSecondCategories(){
      const that = this;
      that.$api
        .get(
          that.requestUrl+
          "/knowledge/goods/getSecondCategoryByParentId/"+this.goodsCategoryId+"?fromDevice=h5",
          {}
        )
        .then((res) => {
          // console.log(res);
          if(res.resultCode === 200 && res.success){
            that.SecondCategories = res.resultData;
          }else{
            console.log("未能获取到数据")
          }
        })
    },
    //通过名称来查询分类
    getSecondCategoriesByName(){
      const that = this;
      var name = this.goodsCategoryNameEn;
      that.$api
      .get(
        that.requestUrl+
        "/knowledge/goods/getSecondCategoryByNameEn/"+name+"?fromDevice=h5",
        {}
      )
      .then((res) => {
        if(res.success){
          that.SecondCategories = res.resultData;
        }else{
          console.error("未能成功获致数据")
        }
      })
    },
  },
};
</script>

<style scoped>
 html,body,#app{
    background-color: #eae8e8;
  }
.page{
   background-color: #eae8e8;
}
.subCategories{
  background-color: #eae8e8;
  height: auto;
  width: auto;
}
.van-nav-bar {
  background-color: #dd405e;
}
.container {
  top: 20px;
}

.icon_nav {
  position: absolute;
  left: 0.21333rem;
  top: 50%;
  left: 162%;
  width: 60px;
  height: 60px;
  transform: translate(0, -50%);
}

.kqb-section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  width: 95%;
  height: 108px;
  margin: 20px 20px;
  border-radius: 30px;
  background-color:#FFF799;
  opacity: 0.7;
}
.title {
  font-size: 45px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #010101;
}
</style>
